import React from "react";
import UserDetails from "../../components/UserDetails";
import { RegisteredUser } from "../../types/generic";
type Props = {
  user: RegisteredUser;
  setUser: (user: RegisteredUser) => void;
  refreshProfile: () => void;
};
export default function UserProfile(props: Props) {
  return <UserDetails {...props} />;
}
